import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'

import { HorarioForm } from './components/Horario';
import { PrimaryRoundedButton } from '../../Buttons/PrimaryRoundedButton';

export const MultiFormHorario = ({ formsStatus='checked', name, onFormsChange, setFormValidation, value }) => {

    const [elements, setElements] = useState((typeof value !== 'undefined') ? value.map(val => ({ id: val._id, horaInicio: val.horaInicio, minutoInicio: val.minutoInicio, horaFin: val.horaFin, minutoFin: val.minutoFin, validation: true })) : []);

    const handleAddElement = () => {
        setElements([...elements, { id: moment().unix(), horaInicio: '', minutoInicio: '', horaFin: '', minutoFin: '', validation: false }]);
    }

    const handleRemoveElement = (id) => {
        setElements(elements.filter(element => element.id !== id));
    }

    const handleSetElementData = (data) => {
        setElements(elements.map(element => {
            if(element.id === data.id){
                return data;
            }else{
                return element;
            }
        }));
    }

    useEffect(() => {
        onFormsChange({ target: { name: name, value: elements.map(element => ({
            horaInicio: element.horaInicio,
            minutoInicio: element.minutoInicio,
            horaFin: element.horaFin,
            minutoFin: element.minutoFin,
        })) } });
        let errorElements = elements.filter(element => (!element.validation));
        setFormValidation(name, (errorElements.length === 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elements])

    return (
        <>
            {(elements.length > 0) ? elements.map((element, index) => <HorarioForm
                key={element.id}
                element={element}
                removeElement={handleRemoveElement}
                onFormChange={handleSetElementData}
                formStatus={formsStatus}
            />) : <div className='text-center'>Día inactivo</div>}
            <div className='centrar'>
                <PrimaryRoundedButton
                    icon="Plus"
                    onClick={handleAddElement}
                    type="button"
                />
            </div>
        </>
    )
}

MultiFormHorario.propTypes = {
    formsStatus: PropTypes.oneOf(['checked', 'checking']),
    name: PropTypes.string.isRequired,
    onFormsChange: PropTypes.func.isRequired,
    setFormValidation: PropTypes.func,
    value: PropTypes.array
}